export function formatINR(n, { compact = false } = {}) {
  if (n == null) return '—';
  if (compact && n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  if (compact && n >= 1000) return `₹${(n / 1000).toFixed(1)}k`;
  return `₹${Number(n).toLocaleString('en-IN')}`;
}

export function formatDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatMonth(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' });
}

export const CATEGORY_LABEL = {
  housing: 'Housing',
  ration: 'Ration',
  medical: 'Medical',
  other: 'Other',
};
